import React, { useEffect, useState } from 'react';
import Dashboard from '../pages/Dashboard';
import { Box, Container, CssBaseline, Grid, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './Sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import Optimization from './Optimization';
import EC2Optimization from '../pages/EC2Optimization';
import EBSOptimization from '../pages/EBSOptimization';
import RDSOptimization from '../pages/RDSOptimization';
import S3Optimization from '../pages/S3Optimization';
import ElasticIPOptimization from '../pages/ElasticIPOptimization';
import ASGOptimization from '../pages/ASGOptimization';
import EBSSnapshotOptimization from '../pages/EBSSnapshotOptimization';
import RDSSnapshotOptimization from '../pages/RDSSnapshotOptimization';
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import { useAuth } from '../state/AuthContext';
import { OnboardRequest } from './OnboardRequest';
import DebugService from '../services/DebugService';
import SnackbarNotification, { SNACKBAR_THEME } from './common/SnackbarNotification';
import InventoryReports from './InventoryReports';
import EC2Inventory from '../pages/EC2Inventory';
import RDSInventory from '../pages/RDSInventory';
import ASGInventory from '../pages/ASGInventory';
import EBSInventory from './EBSInventory';
import InventorySavingCost from './InventorySavingsCost';
import { DateContextProvider } from '../state/DateContext';
import AccountScan from '../pages/AccountScan';
import { UserInvoice } from '../pages/UserInvoice';
import { UserManagement } from './UserManagement';
import { UserTagManagement } from './UserTagManagement';
import { CONST_BUSINESS_NAME, CONST_SITE_LABEL, USER_ROLE } from './common/Helper';
import ErrorBoundary from './ErrorBoundary';
import { MyProfile } from './MyProfile';
import GlobalScan from '../pages/GlobalScan';
import { ROI } from './ROI';
import CostExplorer from '../pages/CostExplorer';
import CloudCostConsole from '../pages/CloudCostConsole';
import DataTransfer from '../pages/DataTransfer';
import { SetupInfrastructure } from './SetupInfrastructure';
import { ManageService } from './ManageService';
import { NotificationSettings } from './NotificationSettings';
import { ExecuteCustomCommands } from './ExecuteCustomCommands';
import LogoLoader from './common/contentloader/LogoLoader';
import { PriceCalculator } from './PriceCalculator';
import CloudEstimator from '../pages/CloudEstimator';
import TagBasedAction from '../pages/TagBasedAction';
import { DevopsMonitoring } from './DevopsMonitoring';
import './common/Styles.css'
import './common/ModernLayout.css'
import '../styles.css'
import ConnectK8sCluster from './ConnectK8sCluster';
import GitRepoConnectionK8s from './GitRepoConnectionK8s';
import DeployTools from './DeployTools';
import DeployAppOnEks from './DeployAppOnEks';
import MonitorK8sCluster from './MonitorK8sCluster';
import MainHeader from './MainHeader';
import { Pricing } from './Pricing';
import AzureOptimization from './AzureOptimization';
import AzureInventory from '../pages/AzureInventory';
import AzureInventoryReports from '../pages/AzureInventoryReports';
import AzureRoi from '../pages/AzureRoi';
import AzureRDSOptimization from './AzureRDSOptimization';
import AIChatbot from './AIChatbot';
import { useZustStore } from '../state/Zuststore';
import VirtualMachine from '../pages/VirtualMachine';
import ManagedDisksOptimization from '../pages/ManagedDisksOptimization';
import AzureDbMySQLOptimization from '../pages/AzureDbMySQLOptimization';
import AzureDbPostgreSQLOptimization from '../pages/AzureDbPostgreSQLOptimization';
import AzureDbSQLOptimization from '../pages/AzureDbSQLOptimization';
import AzureContainerInstanceOptimization from '../pages/AzureContainerInstanceOptimization';
import AzureManagedDiskSnapshotOptimization from '../pages/AzureManagedDiskSnapshotOptimization';
import AzurePublicIPOptimization from '../pages/AzurePublicIPOptimization';
import AzureStaticWebAppOptimization from '../pages/AzureStaticWebAppOptimization';
import AzureWebAppOptimization from '../pages/AzureWebAppOptimization';
import BlobStorageOptimization from '../pages/BlobStorageOptimization';
import VmScaleSetOptimization from '../pages/VmScaleSetOptimization';
/**
 * Main Content Component
 * The component is a parent layout for dashboard flow
 * @returns 
 */
const MainContent = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const {
    isOnboarded,
    isSubscriptionActive,
    loadingUserDetails,
    userDetails,
  } = useAuth()

  const [showEmailVerificationNotification, setShowEmailVerificationNotification] = useState(null)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const { chatbotOpen, toggleChatbot } = useZustStore();

  // useEffect(() => {
  //   // if (loadingUserDetails === false) {

  //     if (isSubscriptionActive === false && isOnboarded) {
  //       DebugService.log(`Main Content Component: Subscription is inactive or user not boarded`)
  //       navigate(CONST_ROUTE_PATH.PRICING)
  //     } else {
  //       if (location.pathname.includes('pricing') && isSubscriptionActive === true) {
  //         navigate(CONST_ROUTE_PATH.DASHBOARD)
  //       }
  //     }
  //   // }
  // }, [isSubscriptionActive, isOnboarded, navigate])

  useEffect(() => {
    // Check for email verification
    if (loadingUserDetails === false) {
      if (userDetails['emailVerified']) {
        setShowEmailVerificationNotification(false)
      } else {
        setShowEmailVerificationNotification(true)
      }

      // Remove "Invoice" page access for ADMIN and READ ONLY users
      if ([USER_ROLE.ADMIN, USER_ROLE.READ_ONLY].includes(userDetails['roleName']) && location.pathname === CONST_ROUTE_PATH.SETTINGS.INVOICE) {
        navigate(CONST_ROUTE_PATH.DASHBOARD)
      }
    }
  }, [loadingUserDetails, userDetails])

  return (
    <ErrorBoundary>
      <DateContextProvider>

        <div className='dashboard-container'>

          {/* Header */}
          <div className='header'>
            <div className='header-left'>
              <IconButton
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                sx={{ 
                  color: '#4a5568',
                  p: 1,
                  '&:hover': { backgroundColor: '#f1f5f9' }
                }}
              >
                <MenuIcon />
              </IconButton>
              <img 
                src={`/${CONST_SITE_LABEL}-logo-black.png`} 
                alt={CONST_BUSINESS_NAME} 
                style={{ height: '32px', width: 'auto' }} 
              />
            </div>
            <div className='header-right'>
              <MainHeader />
            </div>
          </div>

          {/* Main Content Container */}
          <div className='main-content-container'>

            {/* Side Panel */}
            <div className={`side-panel ${sidebarCollapsed ? 'collapsed' : ''}`}>
              <Sidebar sidebarCollapsed={sidebarCollapsed} />
            </div>

            {/* Main Content */}
            <div className='main-content'>
              <div className=''>
                <div className='main'>
                  {(() => {
                    DebugService.log('Main content component: User onboard status: ', isOnboarded)

                    if (!isOnboarded) {
                      // If user has not completed onboarding
                      return loadingUserDetails ? <Container
                        maxWidth='false'
                        sx={{
                          mt: '1vw',
                          ml: '0',
                          mr: '0',
                          width: '100%',
                          maxWidth: '100%'
                        }}
                      >
                        <Grid container style={{
                          marginTop: '80px',
                          padding: '5px',
                          borderRadius: '5px',
                          height: '80vh',
                        }}>
                          <Grid item xs={12} height={'80vh'}><LogoLoader /></Grid>
                        </Grid>
                      </Container>
                        : <OnboardRequest />
                    } else {
                      // If user has completed onboarding
                      switch (location.pathname) {
                        case CONST_ROUTE_PATH.PRICING:
                          return <Pricing />
                        case CONST_ROUTE_PATH.ADD_ACCOUNT:
                          return <OnboardRequest />
                        case CONST_ROUTE_PATH.OPTIMIZATION.EC2:
                          return <EC2Optimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.EBS:
                          return <EBSOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.RDS:
                          return <RDSOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.ELASTIC_IP:
                          return <ElasticIPOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.S3:
                          return <S3Optimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.ASG:
                          return <ASGOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.BIQ_QUERY:
                        case CONST_ROUTE_PATH.OPTIMIZATION.COMPUTE_ENGINE:
                        case CONST_ROUTE_PATH.OPTIMIZATION.CLOUD_RUN:
                        case CONST_ROUTE_PATH.OPTIMIZATION.CLOUD_SQL:
                        case CONST_ROUTE_PATH.OPTIMIZATION.ECS:
                        case CONST_ROUTE_PATH.OPTIMIZATION.LAMBDA:
                          return <Optimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.EBS_SNAPSHOT:
                          return <EBSSnapshotOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.RDS_SNAPSHOT:
                          return <RDSSnapshotOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.VIRTUAL_MACHINE:
                          return <VirtualMachine/>;
                        case CONST_ROUTE_PATH.OPTIMIZATION.MANAGED_DISKS:
                          return <ManagedDisksOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.MANAGED_DISKS_SNAPSHOT:
                          return <AzureManagedDiskSnapshotOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.BLOB_STORAGE:
                          return <BlobStorageOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.VM_SCALE_SET:
                          return <VmScaleSetOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.CONTAINER_INSTANCE:
                          return <AzureContainerInstanceOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.PUBLIC_IP:
                          return <AzurePublicIPOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.AZURE_WEB_APP:
                          return <AzureWebAppOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.AZURE_STATIC_WEB_APP:
                          return <AzureStaticWebAppOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.AZURE_DB_MYSQL:
                          return <AzureDbMySQLOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.AZURE_DB_POSTGRESSQL:
                          return <AzureDbPostgreSQLOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.AZURE_DB_SQL:
                          return <AzureDbSQLOptimization />;
                        case CONST_ROUTE_PATH.OPTIMIZATION.ROI:
                          return <ROI />
                        case CONST_ROUTE_PATH.OPTIMIZATION.AZURE_ROI:
                          return <AzureRoi />
                        case CONST_ROUTE_PATH.INVENTORY.REPORTS:
                          return <InventoryReports />
                        case CONST_ROUTE_PATH.INVENTORY.AZURE_REPORTS:
                          return <AzureInventoryReports />
                        case CONST_ROUTE_PATH.INVENTORY.EC2:
                          return <EC2Inventory />
                        case CONST_ROUTE_PATH.INVENTORY.RDS:
                          return <RDSInventory />
                        case CONST_ROUTE_PATH.INVENTORY.ASG:
                          return <ASGInventory />
                        case CONST_ROUTE_PATH.INVENTORY.EBS:
                          return <EBSInventory />
                        // case CONST_ROUTE_PATH.INVENTORY.LAMBDA:
                        //   return <LambdaInventory />
                        case CONST_ROUTE_PATH.INVENTORY.SAVING_COST:
                          return <InventorySavingCost />
                        case CONST_ROUTE_PATH.INVENTORY.GLOBAL_SCAN:
                          return <GlobalScan />
                        case CONST_ROUTE_PATH.INVENTORY.VIRTUAL_MACHINE:
                        case CONST_ROUTE_PATH.INVENTORY.VIRTUAL_MACHINE_SS:
                        case CONST_ROUTE_PATH.INVENTORY.AZURE_DB_MYSQL:
                        case CONST_ROUTE_PATH.INVENTORY.AZURE_DB_POSTGRESSQL:
                        case CONST_ROUTE_PATH.INVENTORY.AZURE_DB_SQL:
                          return <AzureInventory />
                        case CONST_ROUTE_PATH.INVENTORY.TAG_START_STOP:
                          return <TagBasedAction />
                        case CONST_ROUTE_PATH.BILLING.COST_EXPLORER:
                          return <CostExplorer />
                        case CONST_ROUTE_PATH.BILLING.CLOUD_COST_CONSOLE:
                          return <CloudCostConsole />
                        case CONST_ROUTE_PATH.BILLING.DATA_TRANSFER:
                          return <DataTransfer />
                        case CONST_ROUTE_PATH.SECURITY.ACCOUNT_SCAN_RESULT:
                        case CONST_ROUTE_PATH.SECURITY.ACCOUNT_SCAN:
                          return <AccountScan />
                        case CONST_ROUTE_PATH.DEVOPS.SETUP_INFRASTRUCTURE:
                          return <SetupInfrastructure />
                        case CONST_ROUTE_PATH.DEVOPS.MANAGE_SERVICE:
                          return <ManageService />
                        case CONST_ROUTE_PATH.DEVOPS.EXECUTE_CUSTOM_COMMANDS:
                          return <ExecuteCustomCommands />
                        case CONST_ROUTE_PATH.DEVOPS.MONITORING:
                          return <DevopsMonitoring />
                        case CONST_ROUTE_PATH.INVENTORY.CLOUD_ESTIMATOR:
                          return <CloudEstimator />
                        case CONST_ROUTE_PATH.SETTINGS.INVOICE:
                          return <UserInvoice />
                        case CONST_ROUTE_PATH.SETTINGS.USER_MANAGEMENT:
                          return <UserManagement />
                        case CONST_ROUTE_PATH.SETTINGS.USER_TAG_MANAGEMENT:
                          return <UserTagManagement />
                        case CONST_ROUTE_PATH.SETTINGS.NOTIFICATIONS:
                          return <NotificationSettings />
                        case CONST_ROUTE_PATH.MY_PROFILE:
                          return <MyProfile />
                        case CONST_ROUTE_PATH.K8S.CONNECT_K8S_CLUSTER:
                          return <ConnectK8sCluster />
                        case CONST_ROUTE_PATH.K8S.GIT_REPO_CONNECTION:
                          return <GitRepoConnectionK8s />
                        case CONST_ROUTE_PATH.K8S.DEPLOY_TOOLS:
                          return <DeployTools />
                        case CONST_ROUTE_PATH.K8S.DEPLOY_APP_ON_EKS:
                          return <DeployAppOnEks />
                        case CONST_ROUTE_PATH.K8S.MONITOR_K8S_CLUSTER:
                          return <MonitorK8sCluster />
                        default:
                          return <Dashboard />;
                      }
                    }
                  })()}

                  {/* Verify Email Notification */}
                  {showEmailVerificationNotification && (
                    <SnackbarNotification
                      initialOpen={true}
                      duration={7000}
                      message={'Email has been sent for email verification. Please verify your email.'}
                      actionButtonName={'Ok'}
                      theme={SNACKBAR_THEME.ORANGE}
                      yPosition={'top'}
                      xPosition={'center'}
                    />
                  )}
                </div>
              </div>
            </div>
            {/* AI CHATBOT SIDEBAR */}
           <AIChatbot open={chatbotOpen} onClose={toggleChatbot} />
          </div>
        </div>

      </DateContextProvider>
    </ErrorBoundary>
  )
};

export default MainContent;